import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ChannelGroupExcelStyle } from 'icreate/common/models/channel-excel-style';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChannelSheetStylesApiService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getChannelGroupStyle(groupId: string): Promise<ChannelGroupExcelStyle> {
        return await lastValueFrom(
            this.http.get<ChannelGroupExcelStyle>(`${this.domain}/api/excel/channels/style`, {
                params: {
                    groupId,
                },
            })
        );
    }

    async updateChannelGroupStyle(channelsStyles: ChannelGroupExcelStyle): Promise<any[]> {
        return await lastValueFrom(
            this.http.put<any[]>(`${this.domain}/api/excel/channels/style`, channelsStyles, {
                headers: this.headers,
            })
        );
    }
}
